import { useState, useEffect } from 'react';

import log from '../services/log';
import PubSub from 'pubsub-js'
import Darkmode from '../services/darkmode';

function useDarkmode(props = {landing: false}) {
  const [darkmode, setDarkmode] = useState(localStorage.getItem('darkmode') === 'true' && !props.landing);

	const setStyles = (darkmode) => {
		document.documentElement.style.setProperty('--background-color', Darkmode.get(darkmode).backgroundColor);
		document.documentElement.style.setProperty('--text-muted', Darkmode.get(darkmode).textMuted);
		document.documentElement.style.setProperty('--app-link-color', Darkmode.get(darkmode).linkColor);
		document.documentElement.style.setProperty('--app-link-hover-color', Darkmode.get(darkmode).linkHoverColor);
		document.documentElement.style.setProperty('--hint-underline-color', Darkmode.get(darkmode).hintUnderlineColor);
		document.documentElement.style.setProperty('--hint-underline-hover-color', Darkmode.get(darkmode).hintUnderlineHoverColor);
		document.documentElement.style.setProperty('--mdc-button-text-color', Darkmode.get(darkmode).mdcButtonTextColor);
		document.documentElement.style.setProperty('--mdc-outlined-button-background-color', Darkmode.get(darkmode).mdcOutlinedButtonBackgroundColor);
		document.documentElement.style.setProperty('--mdc-outlined-button-border-color', Darkmode.get(darkmode).mdcOutlinedButtonBorderColor);
		document.documentElement.style.setProperty('--market-portfolio-active-background-color', Darkmode.get(darkmode).marketPortfolioActiveBackgroundColor);
		document.documentElement.style.setProperty('--market-portfolio-active-text-color', Darkmode.get(darkmode).marketPortfolioActiveTextColor);
		document.documentElement.style.setProperty('--view-filter-active-background-color', Darkmode.get(darkmode).viewFilterActiveBackgroundColor);
		document.documentElement.style.setProperty('--view-filter-active-text-color', Darkmode.get(darkmode).viewFilterActiveTextColor);
		document.documentElement.style.setProperty('--mdc-tab-text-color', Darkmode.get(darkmode).tabs.textColor);
		document.documentElement.style.setProperty('--mdc-active-tab-text-color', Darkmode.get(darkmode).tabs.activeTextColor);
		document.documentElement.style.setProperty('--mdc-active-tab-color', Darkmode.get(darkmode).tabs.activeTabColor);
		document.documentElement.style.setProperty('--mdc-tab-indicator', Darkmode.get(darkmode).tabs.tabIndicatorColor);

		document.documentElement.style.setProperty('--coin-name', Darkmode.get(darkmode).coinNameColor);
		document.documentElement.style.setProperty('--coin-price', Darkmode.get(darkmode).coinPriceColor);
		document.documentElement.style.setProperty('--coin-hovered', Darkmode.get(darkmode).coinHoveredColor);
		document.documentElement.style.setProperty('--list-stripe-background-color', Darkmode.get(darkmode).listStripeBackgroundColor);
		document.documentElement.style.setProperty('--input-placeholder', Darkmode.get(darkmode).inputPlaceholderColor);
		document.documentElement.style.setProperty('--input-line-color', Darkmode.get(darkmode).inputLineColor);
		document.documentElement.style.setProperty('--search-input-background-color', Darkmode.get(darkmode).searchInputBackgroundColor);
		document.documentElement.style.setProperty('--search-input-focus-background-color', Darkmode.get(darkmode).searchInputFocusBackgroundColor);
		document.documentElement.style.setProperty('--search-input-border-color', Darkmode.get(darkmode).searchInputBorderColor);
		document.documentElement.style.setProperty('--search-input-focus-border-color', Darkmode.get(darkmode).searchInputFocusBorderColor);
		document.documentElement.style.setProperty('--bottom-view-filters', Darkmode.get(darkmode).bottomViewFiltersColor);
		document.documentElement.style.setProperty('--alert-color-oversold', Darkmode.get(darkmode).alertOversoldColor);
		document.documentElement.style.setProperty('--alert-color-overbought', Darkmode.get(darkmode).alertOverboughtColor);

		// unchecked
		document.documentElement.style.setProperty('--toggle-color', Darkmode.get(darkmode).toggle.toggleColor);
		document.documentElement.style.setProperty('--toggle-background-color', Darkmode.get(darkmode).toggle.toggleBackgroundColor);
		//checked
		document.documentElement.style.setProperty('--toggle-checked-color', Darkmode.get(darkmode).toggle.toggleCheckedColor);
		document.documentElement.style.setProperty('--toggle-checked-background-color', Darkmode.get(darkmode).toggle.toggleCheckedBackgroundColor);

		document.documentElement.style.setProperty('--mdc-theme-text-primary-on-background', Darkmode.get(darkmode).textColor);
		document.documentElement.style.setProperty('--wait-color', Darkmode.get(darkmode).waitColor);
		document.documentElement.style.setProperty('--mdc-theme-surface', Darkmode.get(darkmode).surface);
		document.documentElement.style.setProperty('--settings-dialog-surface', Darkmode.get(darkmode).settingsDialogSurface);
		document.documentElement.style.setProperty('--settings-tab-active-background-color', Darkmode.get(darkmode).settingsTabActiveBackgroundColor);
		document.documentElement.style.setProperty('--settings-tab-active-text-color', Darkmode.get(darkmode).settingsTabActiveTextColor);
		document.documentElement.style.setProperty('--rank-color', Darkmode.get(darkmode).rankColor);
		document.documentElement.style.setProperty('--share-buttons-color', Darkmode.get(darkmode).shareButtonsColor);
	}

	useEffect(() => {
		//log.trace('set useDarkmode');
		setStyles(darkmode);
	}, []);

  useEffect(() => {
    var token = PubSub.subscribe('DARKMODE', (msg, data) => {
      //log.traceTag('auth.onSetDarkmode()', darkmode);
			setDarkmode(!darkmode)
			localStorage.setItem('darkmode', !darkmode)
			setStyles(!darkmode);
    });

    return () => {
      //log.trace('unsubscribe');
      PubSub.unsubscribe(token);
    }
  });

  return [darkmode];
}

export default useDarkmode;
